import React from 'react';

interface PulseCellProps {
  children: React.ReactNode;
  align?: 'left' | 'center' | 'right';
  className?: string;

  // Grid/Sticky support
  isSticky?: boolean;
  stickyPosition?: 'left' | 'top' | 'both';

  // Event handlers
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
}

const PulseCell = ({
  children,
  align = 'left',
  className = '',
  isSticky = false,
  stickyPosition = 'left',
  onMouseEnter,
  onMouseLeave,
}: PulseCellProps) => {
  // Build sticky classes
  const stickyClasses = isSticky
    ? `sticky ${
        stickyPosition === 'both'
          ? 'top-0 left-0'
          : stickyPosition === 'left'
          ? 'left-0'
          : 'top-0'
      }`
    : '';

  const alignClass =
    align === 'center'
      ? 'justify-center text-center'
      : align === 'right'
      ? 'justify-end text-right'
      : 'justify-start text-left';

  return (
    <div
      role="cell"
      className={`px-4 py-2 text-sm text-secondary font-normal font-['Inter'] leading-5 h-12 flex items-center relative ${alignClass} ${stickyClasses} ${className}`}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      {children}
    </div>
  );
};

export default PulseCell;
